/**
 * @generated SignedSource<<cac8a5a50b111a27100ec01b1b81877b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddJiraInstanceInput = {
  apiKey?: string | null | undefined;
  clientId?: string | null | undefined;
  clientSecret?: string | null | undefined;
  issueLimitHard?: number | null | undefined;
  issueLimitSoft?: number | null | undefined;
  name?: string | null | undefined;
  url: string;
  username?: string | null | undefined;
};
export type AddJiraInstanceMutation$variables = {
  input: AddJiraInstanceInput;
};
export type AddJiraInstanceMutation$data = {
  readonly addJiraInstance: {
    readonly jiraInstance: {
      readonly clientId: string | null | undefined;
      readonly defaultSpace: {
        readonly key: string;
        readonly name: string;
      } | null | undefined;
      readonly defaultWorkType: {
        readonly name: string;
      } | null | undefined;
      readonly error: string | null | undefined;
      readonly id: string;
      readonly issueLimitHard: number;
      readonly issueLimitSoft: number;
      readonly name: string | null | undefined;
      readonly spaces: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"JiraInstanceDefaultsFields_spaces">;
      }>;
      readonly spacesUpdated: string | null | undefined;
      readonly updatePending: boolean;
      readonly url: string;
      readonly username: string | null | undefined;
      readonly uuid: any;
    } | null | undefined;
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type AddJiraInstanceMutation = {
  response: AddJiraInstanceMutation$data;
  variables: AddJiraInstanceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraSpace",
  "kind": "LinkedField",
  "name": "defaultSpace",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = [
  (v3/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraWorkType",
  "kind": "LinkedField",
  "name": "defaultWorkType",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "error",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "spacesUpdated",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatePending",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueLimitSoft",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueLimitHard",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddJiraInstanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddJiraInstancePayload",
        "kind": "LinkedField",
        "name": "addJiraInstance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JiraInstance",
            "kind": "LinkedField",
            "name": "jiraInstance",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraSpace",
                "kind": "LinkedField",
                "name": "spaces",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "JiraInstanceDefaultsFields_spaces"
                  }
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v3/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v17/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddJiraInstanceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddJiraInstancePayload",
        "kind": "LinkedField",
        "name": "addJiraInstance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "JiraInstance",
            "kind": "LinkedField",
            "name": "jiraInstance",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraSpace",
                "kind": "LinkedField",
                "name": "spaces",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JiraWorkType",
                    "kind": "LinkedField",
                    "name": "workTypes",
                    "plural": true,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v3/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v17/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "19b4b89bc263b47e5b329d3a7872f680",
    "id": null,
    "metadata": {},
    "name": "AddJiraInstanceMutation",
    "operationKind": "mutation",
    "text": "mutation AddJiraInstanceMutation(\n  $input: AddJiraInstanceInput!\n) {\n  addJiraInstance(input: $input) {\n    jiraInstance {\n      defaultSpace {\n        key\n        name\n      }\n      defaultWorkType {\n        name\n      }\n      error\n      id\n      spaces {\n        ...JiraInstanceDefaultsFields_spaces\n      }\n      spacesUpdated\n      updatePending\n      clientId\n      issueLimitSoft\n      issueLimitHard\n      name\n      url\n      username\n      uuid\n    }\n    problems {\n      __typename\n      message\n    }\n  }\n}\n\nfragment JiraInstanceDefaultsFields_spaces on JiraSpace {\n  key\n  name\n  workTypes {\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "d0af85fd0a0542ce9b05535e0db4e7b6";

export default node;
